import S from "./style.module.css";

export default function RaritiesHeader() {
  return <div className={S.titleWrapper}>RARITIES</div>;
}
